import { moduleConfig } from "@/core/config";
import { FileItem } from "@/shared/FileItem";
import { DriveItem, ManufacturerItem } from "./interface";

export function getDefaultDrive(): Promise<DriveItem> {
  const cfg = moduleConfig
  if (cfg.firmware.provider && cfg.firmware.provider.onDefaultDriveLoad) {
    return cfg.firmware.provider.onDefaultDriveLoad();
  }
  return fetch(`${cfg.firmware.url}/api/v4/box/drive/local`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      seKey: cfg.firmware.secret,
    })
  }).then(res => res.json());
}

export function getManufacturers(connectionType: number, type: number): Promise<ManufacturerItem[]> {
  const cfg = moduleConfig
  if (connectionType == 2) {
    return Promise.resolve([{ name: 'FLEXEM' }])
  }

  if (cfg.firmware.provider && cfg.firmware.provider.onManufacturersLoad) {
    return cfg.firmware.provider.onManufacturersLoad(connectionType, type);
  }

  return fetch(`${cfg.firmware.url}/api/v4/box/drive/manufacturer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      type,
      connectionType,
      seKey: cfg.firmware.secret
    })
  }).then(res => res.json());
}

export function getDrives(connectionType: number, type: number, manufacturer: string): Promise<DriveItem[]> {
  const cfg = moduleConfig
  if (connectionType == 2) {
    return getDefaultDrive().then(data => Promise.resolve([data]));
  }

  if (cfg.firmware.provider && cfg.firmware.provider.onDrivesLoad) {
    return cfg.firmware.provider.onDrivesLoad(connectionType, type, manufacturer);
  }

  return fetch(`${cfg.firmware.url}/api/v4/box/drives`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      manufacturer,
      type,
      connectionType,
      seKey: cfg.firmware.secret
    })
  }).then(res => res.json());
}

export function getMqttDrive(version: number, platform: number): Promise<FileItem> {
  const cfg = moduleConfig
  if (cfg.firmware.provider && cfg.firmware.provider.onMqttDriveLoad) {
    return cfg.firmware.provider.onMqttDriveLoad(version, platform);
  }

  return fetch(`${cfg.firmware.url}/api/v4/se/cloud/mqtt/drive`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      currentVer: version,
      platform,
      seKey: cfg.firmware.secret
    })
  }).then(res => res.json())
}

export function getPlcDrive(plcId: number): Promise<DriveItem> {
  const cfg = moduleConfig
  if (cfg.firmware.provider && cfg.firmware.provider.onPlcDriveLoad) {
    return cfg.firmware.provider.onPlcDriveLoad(plcId);
  }

  return fetch(`${cfg.firmware.url}/api/v4/box/drive/plcId`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      plcId,
      seKey: cfg.firmware.secret
    })
  }).then(res => res.json())
}

/**
 * @deprecated 此方法已经弃用，全部从后端接口获取
 * @param baseUrl
 * @returns
 */
export function getMqttDriveCheckUrl(baseUrl?: string): string | undefined {
  const cfg = moduleConfig
  if (!baseUrl) {
    baseUrl = cfg.firmware?.url
  }
  if (baseUrl) {
    return `${baseUrl}/api/v4/se/cloud/mqtt/drive/check?boxPlatform=$platform&version=$fcs_version`;
  }
  return '';
}
